//  material-ui imports
import { Menu, MenuItem, Divider } from '@mui/material';

// ==============================|| FILEMNGR RENDER CONTEXT MENU ||============================== //

const fileMngrRenderContextMenu = (items = [], contextMenu, setContextMenu) => {
    if (contextMenu === null) {
        return null;
    }

    const handleClose = () => {
        setContextMenu(null);
    };

    return (
        <Menu
            id="context-menu"
            anchorEl={contextMenu}
            open={Boolean(contextMenu)}
            onClose={handleClose}
            PaperProps={{
                style: {
                    width: 200
                }
            }}
        >
            {items.map((item, index) =>
                item?.value !== 'divider' ? (
                    <MenuItem
                        key={index}
                        onClick={() => {
                            item.onClick();
                            handleClose();
                        }}
                        disabled={Boolean(item.disabled)}
                    >
                        {item.name}
                    </MenuItem>
                ) : (
                    <Divider key={index} />
                )
            )}
        </Menu>
    );
};

export default fileMngrRenderContextMenu;
